import { TESTIMONIALS } from '../utils/constants';
import AmbientBackground from './AmbientBackground';
import { TiltSurface } from './InteractiveSurface';

const Testimonials = () => {
    return (
        <section className='testimonials-section'>
            <AmbientBackground />
            <div className='section-heading'>
                <span className='eyebrow'>Client Voices</span>
                <h2>Trusted with what matters most</h2>
            </div>

            <div className='testimonials-grid'>
                {TESTIMONIALS.map((t) => (
                    <TiltSurface className='testimonial-card tilt-surface' key={t.name}>
                        <p className='quote'>&ldquo;{t.quote}&rdquo;</p>
                        <div className='testimonial-author'>
                            <div className='avatar-initials'>{t.name.charAt(0)}</div>
                            <div>
                                <strong>{t.name}</strong>
                                <span>{t.role}</span>
                            </div>
                        </div>
                    </TiltSurface>
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
